import { render, staticRenderFns } from "./PortalAccountHistoryModal.vue?vue&type=template&id=2fe8f4e2&scoped=true&"
import script from "./PortalAccountHistoryModal.vue?vue&type=script&lang=js&"
export * from "./PortalAccountHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./PortalAccountHistoryModal.vue?vue&type=style&index=0&id=2fe8f4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe8f4e2",
  null
  
)

export default component.exports